import { inject, Injectable } from '@angular/core';
import { ConsentService, type CONSENT_LEVEL_VALUES } from '@core/consent';
import { PlatformService } from '@core/platform';
import { WINDOW } from '@innogy/utils-dom';

export const REFERRER_COOKIE_NAME = 'dreferrer';

@Injectable({
  providedIn: 'root',
})
export class CookiewallService {
  readonly #platformService = inject(PlatformService);
  readonly #window = inject(WINDOW);
  readonly #consentService = inject(ConsentService);

  /**
   * Determines wether or not
   * @returns boolean indicating whether or not consent is required
   */
  public isCookieConsentPromptRequired() {
    // never run on server.
    if (!this.#platformService.isClient()) {
      return false;
    }

    const isWhitelistedPage =
      this.#window.document.URL.match(/cookies|privacyverklaring/g) !== null;
    const hasConsent = this.#consentService.consentGranted();

    return !isWhitelistedPage && !hasConsent;
  }

  /**
   * Opts the end-user into the usage of tracking cookies on this device.
   */
  public setConsentLevel(level: CONSENT_LEVEL_VALUES) {
    this.#consentService.setCookieConsentLevel(level);
  }
}
